import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'coins',
})
export class CoinsPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(value: number | string | undefined | null): string | null {
    if (value === undefined || value === null || value === '') {
      return '';
    }

    const numericValue = Number(value);

    if (Number.isNaN(numericValue)) {
      return '';
    }

    return numericValue % 1 === 0
      ? this.currencyPipe.transform(numericValue, 'USD', 'symbol', '1.0-0')
      : this.currencyPipe.transform(numericValue, 'USD', 'symbol', '1.2-2');
  }
}
